import React from 'react'
import PropTypes from 'prop-types'


import DoughnutChartWithIcon from '../DoughnutChartWithIcon'
import {
  _ChartAndInfo,
  _InfoHolder,
  _Percent,
  _Title,
  _Subtitle,
} from './styles.js'


const ChartAndInfo = ({ percent, iconName, title, subtitle }) => (
  <_ChartAndInfo align="center">
    <DoughnutChartWithIcon percent={percent} iconName={iconName} />
    <_InfoHolder>
      <_Percent>{percent}%</_Percent>
      <_Title>{title}</_Title>
      <_Subtitle>{subtitle}</_Subtitle>
    </_InfoHolder>
  </_ChartAndInfo>
)


ChartAndInfo.propTypes = {
  percent: PropTypes.number,
  iconName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default ChartAndInfo
